/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Calendar_WebcalInputs */



/**
* | output |
* | --- |
* | "Open in calendar app" |
*
* @param {Tournaments_Calendar_WebcalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_webcal = /** @type {((inputs?: Tournaments_Calendar_WebcalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_WebcalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir dans l'application de calendrier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir en la aplicación de calendario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Abrir no aplicativo de calendário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri nell'app del calendario")
	return /** @type {LocalizedString} */ ("Open in calendar app")
});